import * as turf from '@turf/turf'
var numberRegexp = /[-+]?([0-9]*\.[0-9]+|[0-9]+)([eE][-+]?[0-9]+)?/;
var coordFormat = new RegExp('^' + numberRegexp.source + '(\\s' + numberRegexp.source + '){1,}');

export const geometryUtil = {
    getGeometryByPoint: function (x, y, range = 0.1, num = 30) {
        let muitPointArr1 = [];
        let muitPointArr2 = [];
        let muitPointArr3 = [];
        let muitPointArr4 = [];
        let muitPointArrs = [];
        let muitPointNum = Math.ceil(Math.random() * num)
        if (muitPointNum < 4) {
            muitPointNum += 3
        }
        let scope4 = [parseInt(muitPointNum / 4), parseInt(muitPointNum / 4), parseInt(muitPointNum / 4), parseInt(muitPointNum / 4) + muitPointNum % 4];
        for (let i = 0; i < scope4.length; i++) {
            for (let j = 0; j < scope4[i]; j++) {
                //第一象限点
                if (i === 0) {
                    muitPointArr1.push([x + Math.random() * range, y + Math.random() * range]);
                }
                //第二象限点
                else if (i === 1) {
                    muitPointArr2.push([x - Math.random() * range, y + Math.random() * range]);
                }
                //第三象限点
                else if (i === 2) {
                    muitPointArr3.push([x - Math.random() * range, y - Math.random() * range]);
                }
                //第四象限点
                else {
                    muitPointArr4.push([x + Math.random() * range, y - Math.random() * range]);
                }
            }
        }
        muitPointArr1.sort(function (x, y) {
            return y[0] - x[0];
        });
        muitPointArr2.sort(function (x, y) {
            return y[0] - x[0];
        });
        muitPointArr3.sort(function (x, y) {
            return x[0] - y[0];
        });
        muitPointArr4.sort(function (x, y) {
            return x[0] - y[0];
        });
        muitPointArr1.map(m => m[1]).sort((x, y) => x - y).forEach((f, i) => muitPointArr1[i][1] = f)
        muitPointArr2.map(m => m[1]).sort((x, y) => y - x).forEach((f, i) => muitPointArr2[i][1] = f)
        muitPointArr3.map(m => m[1]).sort((x, y) => x - y).forEach((f, i) => muitPointArr3[i][1] = f)
        muitPointArr4.map(m => m[1]).sort((x, y) => y - x).forEach((f, i) => muitPointArr4[i][1] = f)
        muitPointArrs = [...muitPointArr1, ...muitPointArr2, ...muitPointArr3, ...muitPointArr4];
        let geometry = {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [muitPointArrs]
            },
            "properties": {
                "prop0": "value0",
                "color": "red"
            },
        }
        return geometry;
    },
    //生成格网
    getGrid: function (polygon = 4, cellSide = 50, bbox = [-95, 30, -85, 40]) {
        var options = { units: 'miles' };
        var cell = turf.squareGrid(bbox, cellSide, options);
        if (polygon === 3) {
            cell = turf.triangleGrid(bbox, cellSide, options);
        } else if (polygon === 4) {
            cell = turf.squareGrid(bbox, cellSide, options);
        } else if (polygon === 6) {
            cell = turf.hexGrid(bbox, cellSide, options);
        } else {
            cell = turf.pointGrid(bbox, cellSide, options);
        }
        return cell;
    },
    generateHexagon: function (center, size) {
        const angleStep = 2 * Math.PI / 6;
        const points = [];
        for (let i = 0; i < 6; i++) {
            const angle = i * angleStep;
            const pointX = center[0] + size * Math.cos(angle);
            const pointY = center[1] + size * Math.sin(angle);
            points.push([pointX, pointY]);
        }
        return points;
    },
    generateHexagonalGrid: function (rows, cols, size) {
        const grid = [];
        const hexSideLength = size * Math.sqrt(3);
        const hexHeight = size * 1.5;
        const margin = size / 2;
        const startX = -cols / 2 * (hexSideLength + margin);
        const startY = -rows / 2 * (hexHeight + margin);

        for (let i = 0; i < rows; i++) {
            for (let j = 0; j < cols; j++) {
                const centerX = startX + j * (hexSideLength + margin);
                const centerY = startY + i * (hexHeight + margin);
                // console.log(generateHexagon([centerX, centerY], size));
                // grid.push(generateHexagon([centerX, centerY], size));
            }
        }
        return grid;
    },
    wgs84ToMercator: function () {
        //npm install @turf/projection
        var pt = turf.point([-71, 41]);
        return turf.toMercator(pt);
    },
    mercatorToWgs84: function () {
        //npm install @turf/projection
        var pt = turf.point([-7903683.846322424, 5012341.663847514]);
        return turf.toWgs84(pt);
    },
        //Leaflet的Bounds转换为geoJson格式geometry
    latLngBounds2GeoJson: function (latLngBound) {
        const p1 = latLngBound.getNorthWest(),
            p2 = latLngBound.getSouthEast();
        return {
            type: "Polygon",
            coordinates: [
                [
                    [p1.lng, p1.lat],
                    [p2.lng, p1.lat],
                    [p2.lng, p2.lat],
                    [p1.lng, p2.lat],
                    [p1.lng, p1.lat]
                ]
            ]
        };
    },

    //geoJson格式的geometry转成leaflet格式的geometry
    coordinates2leaflet: function (coordinates) {
        if (Array.isArray(coordinates)) {
            const items = [];
            let coords = null;
            coordinates.forEach(item => {
                coords = this.coordinates2leaflet(item);
                if (Array.isArray(coords))
                    items.push(coords);
                else
                    items.unshift(coords);
            });
            return items;
        }
        else {
            return coordinates;
        }
    },
    /**
     * WKT转geoJSON
     * @returns GeoJSON.
     */
    wktToGeoJSON: function (wkt) {
        let parts = wkt.split(';');
        let _ = parts.pop();
        let srid = (parts.shift() || '').split('=').pop();

        let i = 0;

        function $(re) {
            let match = _.substring(i).match(re);
            if (!match) return null;
            else {
                i += match[0].length;
                return match[0];
            }
        }

        function crs(obj) {
            if (obj && srid.match(/\d+/)) {
                obj.crs = {
                    type: 'name',
                    properties: {
                        name: 'urn:ogc:def:crs:EPSG::' + srid
                    }
                };
            }

            return obj;
        }

        function white() { $(/^\s*/); }

        function multicoords() {
            white();
            let depth = 0;
            let rings = [];
            let stack = [rings];
            let pointer = rings;
            let elem;

            while (elem =
                $(/^(\()/) ||
                $(/^(\))/) ||
                $(/^(,)/) ||
                $(coordFormat)) {
                if (elem === '(') {
                    stack.push(pointer);
                    pointer = [];
                    stack[stack.length - 1].push(pointer);
                    depth++;
                } else if (elem === ')') {
                    // For the case: Polygon(), ...
                    if (pointer.length === 0) return null;

                    pointer = stack.pop();
                    // the stack was empty, input was malformed
                    if (!pointer) return null;
                    depth--;
                    if (depth === 0) break;
                } else if (elem === ',') {
                    pointer = [];
                    stack[stack.length - 1].push(pointer);
                } else if (!elem.split(/\s/g).some(isNaN)) {
                    Array.prototype.push.apply(pointer, elem.split(/\s/g).map(parseFloat));
                } else {
                    return null;
                }
                white();
            }

            if (depth !== 0) return null;

            return rings;
        }

        function coords() {
            let list = [];
            let item;
            let pt;
            while (pt =
                $(coordFormat) ||
                $(/^(,)/)) {
                if (pt === ',') {
                    list.push(item);
                    item = [];
                } else if (!pt.split(/\s/g).some(isNaN)) {
                    if (!item) item = [];
                    Array.prototype.push.apply(item, pt.split(/\s/g).map(parseFloat));
                }
                white();
            }

            if (item) list.push(item);
            else return null;

            return list.length ? list : null;
        }

        function point() {
            if (!$(/^(point(\sz)?)/i)) return null;
            white();
            if (!$(/^(\()/)) return null;
            let c = coords();
            if (!c) return null;
            white();
            if (!$(/^(\))/)) return null;
            return {
                type: 'Point',
                coordinates: c[0]
            };
        }

        function multipoint() {
            if (!$(/^(multipoint(\sz)?)/i)) return null;
            white();
            let newCoordsFormat = _
                .substring(_.indexOf('(') + 1, _.length - 1)
                .replace(/\(/g, '')
                .replace(/\)/g, '');
            _ = 'MULTIPOINT (' + newCoordsFormat + ')';
            let c = multicoords();
            if (!c) return null;
            white();
            return {
                type: 'MultiPoint',
                coordinates: c
            };
        }

        function multilinestring() {
            if (!$(/^(multilinestring(\sz)?)/i)) return null;
            white();
            let c = multicoords();
            if (!c) return null;
            white();
            return {
                type: 'MultiLineString',
                coordinates: c
            };
        }

        function linestring() {
            if (!$(/^(linestring(\sz)?)/i)) return null;
            white();
            if (!$(/^(\()/)) return null;
            let c = coords();
            if (!c) return null;
            if (!$(/^(\))/)) return null;
            return {
                type: 'LineString',
                coordinates: c
            };
        }

        function polygon() {
            if (!$(/^(polygon(\sz)?)/i)) return null;
            white();
            let c = multicoords();
            if (!c) return null;
            return {
                type: 'Polygon',
                coordinates: c
            };
        }

        function multipolygon() {
            if (!$(/^(multipolygon(\sz)?)/i)) return null;
            white();
            let c = multicoords();
            if (!c) return null;
            return {
                type: 'MultiPolygon',
                coordinates: c
            };
        }

        function geometrycollection() {
            let geometries = [];
            let geometry;

            if (!$(/^(geometrycollection)/i)) return null;
            white();

            if (!$(/^(\()/)) return null;
            while (geometry = root()) {
                geometries.push(geometry);
                white();
                $(/^(,)/);
                white();
            }
            if (!$(/^(\))/)) return null;

            return {
                type: 'GeometryCollection',
                geometries: geometries
            };
        }

        function root() {
            return point() ||
                linestring() ||
                polygon() ||
                multipoint() ||
                multilinestring() ||
                multipolygon() ||
                geometrycollection();
        }

        return crs(root());
    },
    /**
     * geoJSON转WKT
     * @returns WKT.
     */
    geoJSONToWkt: function (geoJSON) {
        if (geoJSON.type === 'Feature') {
            geoJSON = geoJSON.geometry;
        }

        function pairWKT(c) {
            return c.join(' ');
        }

        function ringWKT(r) {
            return r.map(pairWKT).join(', ');
        }

        function ringsWKT(r) {
            return r.map(ringWKT).map(wrapParens).join(', ');
        }

        function multiRingsWKT(r) {
            return r.map(ringsWKT).map(wrapParens).join(', ');
        }

        function wrapParens(s) { return '(' + s + ')'; }

        let gJ = geoJSON;
        switch (gJ.type) {
            case 'Point':
                if (gJ.coordinates && gJ.coordinates.length === 3)
                    return 'POINT Z (' + pairWKT(gJ.coordinates) + ')';
                else return 'POINT (' + pairWKT(gJ.coordinates) + ')';

            case 'LineString':
                if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0].length === 3)
                    return 'LINESTRING Z (' + ringWKT(gJ.coordinates) + ')';
                else return 'LINESTRING (' + ringWKT(gJ.coordinates) + ')';

            case 'Polygon':
                if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0].length === 3)
                    return 'POLYGON Z (' + ringsWKT(gJ.coordinates) + ')';
                else return 'POLYGON (' + ringsWKT(gJ.coordinates) + ')';

            case 'MultiPoint':
                if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0].length === 3)
                    return 'MULTIPOINT Z (' + ringWKT(gJ.coordinates) + ')';
                else return 'MULTIPOINT (' + ringWKT(gJ.coordinates) + ')';

            case 'MultiLineString':
                if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0].length === 3)
                    return 'MULTILINESTRING Z (' + ringsWKT(gJ.coordinates) + ')';
                else return 'MULTILINESTRING (' + ringsWKT(gJ.coordinates) + ')';

            case 'MultiPolygon':
                if (gJ.coordinates && gJ.coordinates[0] && gJ.coordinates[0][0] && gJ.coordinates[0][0] && gJ.coordinates[0][0][0].length === 3)
                    return 'MULTIPOLYGON Z (' + multiRingsWKT(gJ.coordinates) + ')';
                else return 'MULTIPOLYGON (' + multiRingsWKT(gJ.coordinates) + ')';


            case 'GeometryCollection':
                return 'GEOMETRYCOLLECTION (' + gJ.geometries.map(this.geoJSONToWkt).join(', ') + ')';

            default:
                throw new Error('stringify requires a valid GeoJSON Feature or geometry object as input');
        }
    },
    /**
     * wkt转geometry
     * @param {*} wkt 
     * @returns 
     */
    wktToGeometry(wkt) {
        if (!wkt) {
            return;
        }

        let type = wkt.match(/[a-zA-Z]+/g);
        if (!type) {
            return null;
        }

        let coordinates = wkt.replace(type, '');
        coordinates = coordinates.replaceAll('(', '[');
        coordinates = coordinates.replaceAll(')', ']');
        coordinates = coordinates.replaceAll(' ', ',');

        function coordinatesFormat(coordinates) {
            const arr = [];
            if (!isArr) {
                return;
            }
            for (let i = 0; i < coordinates.length; i++) {
                if (isArr(coordinates[i])) {
                    coordinates[i] = coordinatesFormat(coordinates[i]);
                } else {
                    if (i % 2 === 0) {
                        arr.push([coordinates[i + 1], coordinates[i]]);
                    }
                    if (i === coordinates.length - 1) {
                        coordinates = arr;
                    }
                }
            }
            return coordinates;
        }

        function getType(type) {
            let newType = type.toLowerCase();

            if (newType.includes('point')) {
                return 'point';
            }

            if (newType.includes('line')) {
                return 'line';
            }

            if (newType.includes('polygon')) {
                return 'polygon';
            }

            return newType;
        }

        function isArr(arr) {
            return Array.isArray(arr);
        }
        let lngLats = coordinatesFormat(JSON.parse(coordinates));

        const newType = getType(type[0]);

        // 点特殊处理
        if (newType === 'point') {
            lngLats = lngLats[0];
        }

        return {
            type: newType,
            coordinates:lngLats
        };
    },
    latLngArrayToWkt:function(geofence){
        if(geofence.length===1){
            return `POINT(${JSON.parse(geofence).map(m=>`${m.y} ${m.x}`).join(",")})`;
        }else if(geofence.length>1){
            return `POLYGON((${JSON.parse(geofence).map(m=>`${m.y} ${m.x}`).join(",")}))`;
        }else{
            return `POLYGON((${JSON.parse(geofence).map(m=>`${m.y} ${m.x}`).join(",")}))`;
        }
    },
    latLngArrayToGeoJSON:function(geofence){
        return {
            "type":"Polygon",
            "coordinates":this.parseString(geofence)?.map(m=>[m.y,m.x])
        }
    },
    parseString:function(param) {
        try {
            return JSON.parse(param);
        } catch (e) {
            // 解析失败且不是 WKT，说明是非法或未知格式
            return null;
        }
    },
    getCoordByGeoJSON:function(geoJSON){
        if(typeof geoJSON === "string"){
            try {
                return JSON.parse(geoJSON)?.coordinates;
            } catch (e) {
                // 解析失败且不是 WKT，说明是非法或未知格式
                return null;
            } 
        }else if(typeof geoJSON === "object"){
            return geoJSON.coordinates;
        }else{
            return null;
        }
    },
    /**
     * 判断wkt是否为多个(multi)多边形，或者多边形（polygon）有镂空
     * @param {*} wkt 
     * @returns 
     */
    wktIsSinglePolygon(wkt){
        const normalized = wkt.toUpperCase().replace(/\s+/g, '');
        //多边形
        if (normalized.startsWith('MULTIPOLYGON')) return true;
    
        const coordMatch = normalized.match(/POLYGON(.+)$/);
        if (!coordMatch) return true;
    
        const content = coordMatch[1];
        let depth = 0;
        let polyStart = 0;
        const polygons = [];
    
        // 获取多边形
        for (let i = 0; i < content.length; i++) {
            if (content[i] === '(') {
                if (++depth === 2) polyStart = i + 1; // 进入多边形坐标部分
            } else if (content[i] === ')') {
                if (--depth === 1) { // 完成一个多边形
                    polygons.push(content.substring(polyStart, i));
                }
            }
        }

        if (polygons.length > 1) return true; // 存在内环
        return false;
    },
    /**
     * polygon缓冲区
     * @param {*} geometry 
     * @param {*} distance 
     * @returns 
     */
    bufferPoly:function(geometry, distance = 1){
        const {type,coordinates} = geometry;
        var geom = null;
        switch (type) {
            case "Point":
                geom = turf.point(coordinates);
            case "LineString":
                geom = turf.lineString(coordinates);
            case "Polygon":
                geom = turf.polygon(coordinates);
            case "MultiPoint":
                geom = turf.multiPoint(coordinates);
            case "MultiLineString":
                geom = turf.multiLineString(coordinates);
            case "MultiPolygon":
                geom = turf.multiPolygon(coordinates);
            default:
                geom = null;
        }
        var bufferRes = geom?turf.buffer(geom, distance, { units: "kilometers" }):null;
        return bufferRes;
    },
    createRectangle:function(center={lat: 0, lng: 0},width=100,height=100){
        let rightX = center.lat + width/2;
        let rightY = center.lng + height/2;
        let leftX = center.lat - width/2;
        let leftY = center.lng - height/2;
        var bbox = [[rightX,rightY],[leftX,leftY]];
        // var squared = turf.square(bbox);
        // console.log(squared);
        return bbox;
    },
    createRect:function(center={lat: 0, lng: 0},width=100,height=100){
        let rightTop = [center[0] + width/2,center[1] + height/2];
        let rightBottom = [center[0] + width/2,center[1] - height/2];
        let leftBottom = [center[0] - width/2,center[1] - height/2];
        let leftTop = [center[0] - width/2,center[1] + height/2];
        let bounds = [rightTop,rightBottom,leftBottom,leftTop];
        return bounds;
    },
    getCenterforGeom:function(coordinates){
        var polygon = turf.polygon(coordinates.length!=1?[coordinates]:coordinates);
        var center = turf.center(polygon,{properties: {desc: "center point"}});
        return center?.geometry?.coordinates;
    },
    parsePolygonToCoords:function(wkt) {
        const match = wkt.match(/\(\((.*?)\)\)/);
        console.log(match);
        if (!match) throw new Error("Invalid POLYGON format");
        const numbers = wkt.match(/\d+(?:\.\d+)?/g) || [];
        return numbers;
    },
    /**
    * 判断地理空间数据类型
    * @param {any} dataString 输入的数据字符串
    * @returns {string} 返回数据类型：'geojson' | 'wkt' | 'xy_array' | 'unknown'
    */
    detectGeometryType: function (dataString) {
        // console.log(JSON.parse(dataString));
        // console.log(typeof JSON.parse(dataString));
        if (!dataString) return 'unknown';

        // 1. 如果是字符串，尝试先处理成 WKT 判断，或解析为对象
        const trimmed = dataString.trim();
        // 检查是否符合 WKT 特征 (以常见 WKT 关键字开头)
        const wktRegex = /^(point|linestring|polygon|multipoint|multilinestring|multipolygon|geometrycollection)/i;
        if (wktRegex.test(trimmed)) {
            return 'wkt';
        }


        // 尝试解析 JSON 字符串
        let parsedData = null;
        try {
            parsedData = JSON.parse(dataString);
        } catch (e) {
            // 解析失败且不是 WKT，说明是非法或未知格式
            return 'unknown';
        }

        // 2. 检查是否为数组格式 (如你给出的 [{"x":..., "y":...}, ...])
        if (Array.isArray(parsedData)) {
            if (parsedData.length === 0) return 'xy_array'; // 空数组默认归为此类或视情况而定

            // 取第一个元素检查是否有 x 和 y 属性
            const firstItem = parsedData[0];
            if (firstItem && typeof firstItem === 'object') {
                const hasX = 'x' in firstItem || 'X' in firstItem;
                const hasY = 'y' in firstItem || 'Y' in firstItem;
                if (hasX && hasY) {
                    return 'xy_array';
                }
            }
            return 'unknown';
        }

        // 3. 检查是否为 GeoJSON 对象
        if (typeof parsedData === 'object' && parsedData !== null) {
            // GeoJSON 规范中必须包含 type 属性
            const geoJsonTypes = ['Feature', 'FeatureCollection', 'Point', 'MultiPoint', 'LineString', 'MultiLineString', 'Polygon', 'MultiPolygon', 'GeometryCollection'];
            if (parsedData.type && geoJsonTypes.includes(parsedData.type)) {
                return 'geojson';
            }
        }

        return 'unknown';
    },
    anyToToGeometry:function(data) {
        const type = this.detectGeometryType(data);
        switch (type) {
            case 'wkt':
                return this.wktToGeoJSON(data).coordinates;
            case 'geojson':
                return this.getCoordByGeoJSON(data);
            case 'xy_array':
                console.log(this.latLngArrayToGeoJSON(data));
                return this.latLngArrayToGeoJSON(data).coordinates;
            case 'unknown':
                return null;
            default:
                throw new Error('格式错误');
        }
    }
}